import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["badgeContent", "className", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// Components
import { Badge } from 'antd';

// Constants
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';

// Helpers
import { isUniDigitCount } from './badgeWrapper.helper';

// Styles
import s from './badgeWrapper.module.scss';
var BadgeWrapper = function BadgeWrapper(_ref) {
  var badgeContent = _ref.badgeContent,
    className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isUniDigit = isUniDigitCount(badgeContent);
  var badgeClassName = cx(className, s.badgeWrapper, _defineProperty({}, s.uniCount, isUniDigit));
  return /*#__PURE__*/React.createElement(Badge, _extends({
    count: badgeContent,
    className: badgeClassName
  }, rest), children);
};
BadgeWrapper.propTypes = {
  badgeContent: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node
};
BadgeWrapper.defaultProps = {
  badgeContent: null,
  className: EMPTY_STRING,
  children: null
};
export default BadgeWrapper;